module.exports = "/lucky-balls/img/infobox/info_Box_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_015.png
// module id = 1080
// module chunks = 0